import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CampaignWizard from '../../campaign-wizard/CampaignWizard';
import { useEyeconxStore } from '../../../store/eyeconxStore';

function CreateSmsNewsletter() {
    const navigate = useNavigate();
    const clinicId = useEyeconxStore((state) => state.user?.clinicId);

    const steps = [
        { id: 1, title: 'Message Content', subtitle: 'Write SMS with keywords', component: 'MessageContent' },
        { id: 2, title: 'Newsletter Information', subtitle: 'Basic information', component: 'CampaignInformation' },
        { id: 3, title: 'Patient List', subtitle: 'Select patients that will receive SMS', component: 'PatientList' },
        { id: 4, title: 'Complete', subtitle: 'Process the Newsletter', component: 'Complete' },
    ];

    const handleSubmit = async (formData) => {
        const name = formData.campaignName?.trim();
        const message = formData.messageContent?.trim();
        const patientIds = (formData.selectedPatients || [])
            .map((patient) => patient.id)
            .filter(Boolean);

        if (!clinicId) {
            toast.error('Clinic is not available. Please sign in again.');
            return;
        }
        if (!name) {
            toast.error('Newsletter name is required.');
            return;
        }
        if (!message) {
            toast.error('SMS message is required.');
            return;
        }
        if (patientIds.length === 0) {
            toast.error('Select at least one patient before launching.');
            return;
        }

        // Launch API will be wired in a follow-up; keep validation + UX ready.
        toast.info(
            `SMS newsletter ready for ${patientIds.length} recipient${
                patientIds.length === 1 ? '' : 's'
            }. Launch API not connected yet.`
        );
        navigate('/newsletter/sms');
    };

    return (
        <CampaignWizard
            title="Create SMS Newsletter"
            description="Send regular updates and news to your patients via SMS."
            icon="bi-chat-text"
            navigatePath="/newsletter/sms"
            campaignType="sms"
            entityLabel="Newsletter"
            patientCampaignType="newsletter"
            steps={steps}
            onSubmit={handleSubmit}
        />
    );
}

export default CreateSmsNewsletter;
